import ajax from "./helpers/ajax";
import { addDelegatedEventListener } from "./helpers/events";
import { isAuthError, getErrorMessage } from "./helpers/errors";
import { addNotification } from "./helpers/notifications";
import user from "./User";

/**
 * Favorites
 */

const Favourites = {
  init: () => {
    addDelegatedEventListener(
      "click",
      ".favourite-marker-trigger:not([data-disabled])",
      (e) => {
        if (!user.isLoggedIn()) {
          // Show login modal
          user.login();

          // Prevent default action
          return;
        }

        const postId = e.target.dataset.postId;
        const isFavourite = e.target.dataset.isFavourite === "true";
        const subAction = isFavourite ? "unmark" : "mark";

        Favourites.change(postId, subAction);
      }
    );
  },
  change: (postId, subAction) => {
    // Select all triggers for this post
    const triggers = document.querySelectorAll(
      '.favourite-marker-trigger[data-post-id="' + postId + '"]'
    );

    // Disable all triggers for this post
    triggers.forEach((trigger) => {
      trigger.dataset.disabled = true;
    });

    return ajax
      .post("digiteket_change_favourite", {
        post_id: postId,
        sub_action: subAction,
      })
      .then(() => {
        triggers.forEach((trigger) => {
          // Set the correct state for the trigger depending on the subAction
          if (subAction === "mark") {
            trigger.dataset.isFavourite = "true";
            trigger.title = trigger.dataset.unmarkText;
          } else {
            trigger.dataset.isFavourite = "false";
            trigger.title = trigger.dataset.markText;
          }

          // Enable the button again
          delete trigger.dataset.disabled;
        });
      })
      .catch((error) => {
        if (isAuthError(error)) {
          // Show login modal
          user.login((error) => {
            if (!error) {
              // If login was successful, try to change the favourite again
              Favourites.change(postId, subAction);
            } else {
              // Otherwise, show error message
              addNotification(getErrorMessage(error));
            }
          });
        } else {
          // Show error message
          addNotification(getErrorMessage(error));
        }
      });
  },
  mark: (postId) => {
    return Favourites.change(postId, "mark");
  },
  unmark: (postId) => {
    return Favourites.change(postId, "unmark");
  },
};

export default Favourites;
